import { I18n } from 'i18n-js'
import en from './locale/en.json'
import { tx, t } from '@transifex/native'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/es-us'

const localeKey = '@locale'

tx.init({
  token: '1/e0519fc44ba1497b462d3885de9aa565c6a65e5f'
})

const i18n = new I18n({ en })

const updateDayjsLocale = locale => {
  const dayjsLocale = locale === 'es_US' ? 'es-us' : 'en'
  dayjs.locale(dayjsLocale)
}

const updateLocaleStrings = async locale => {
  window.embedded_svc.settings.language = locale
  window.embedded_svc.settings.defaultMinimizedText = $t('chat.chat')
  window.embedded_svc.settings.offlineSupportMinimizedText =
    $t('chat.offlineChat')
  window.embedded_svc.settings.loadingText = $t('chat.loading')
}

export const setLocale = async locale => {
  // Set the language code
  await tx.setCurrentLocale(locale)
  await updateLocaleStrings(locale)

  // Set the layout direction to RTL if the language is Arabic or Hebrew
  localStorage.setItem(localeKey, locale)

  updateDayjsLocale(locale)

  return locale
}

export const $t = (key, params = {}) => {
  const defaults = params?.defaults || i18n.t(key)
  return t(i18n.t(key, { defaults, ...params }), params)
}

const getLocaleFromUrl = () => {
  const queryParams = new URLSearchParams(window.location.search)
  return queryParams.get('locale') === 'es' ? 'es_US' : 'en'
}

export const getLocale = () => {
  const localeFromUrl = getLocaleFromUrl()
  const locale = localeFromUrl ? localeFromUrl : localStorage.getItem(localeKey)
  if (!locale) return 'en'
  else {
    return locale
  }
}

export default $t
